module.exports = {"TXTCLI_LoadingXX":{"id":"TXTCLI_LoadingXX","defaultMessage":"Laddar...","flags":["TRACK"],"track":"Loading..."}}